import React, { useEffect, useState } from "react";
import { useBulkOrder } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function BulkOrder({ setTrigger, name, setForm, setBulkOrder, orderId }) {
  const { setBulkOrderRequest } = useBulkOrder();
  const { setToaster } = useToast();

  const [bulkOrderCount, setBulkOrderCount] = useState();
  const options = Array.from({ length: 10 }, (_, index) => index + 1);
  useEffect(() => {
    setTimeout(() => {
      setTrigger(["hover", "focus"]);
      setForm(name);
    }, 5000);
  }, []);

  return (
    <div>
      <div>
        <p className="m-0 mb-2 fw-bold">Bulk Orders</p>
        <div className="d-flex align-items-center">
          <select
            style={{ width: "7rem", height: "2rem" }}
            className="bg-white border rounded-start"
            onMouseDown={(event) => event.stopPropagation()}
            onChange={(event) => {
              setBulkOrderCount(event.target.value);
            }}
            defaultValue=""
          >
            <option value="" disabled hidden>
              Order Count
            </option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              // setBulkOrder(false);
              setBulkOrderRequest(bulkOrderCount, orderId,setToaster);
              setForm(name);
              setTrigger(["hover", "focus"]);
              // setBulkOrder(false);
            }}
            className="border rounded-end bg-primary text-white"
            style={{ height: "2rem" }}
          >
            save
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkOrder;
